import React from "react"
import { FormSkeletonLayout, formSkeletonConfig } from "utils/forms";
import { authOptions } from "site/rootWidget";
import { RootLayout } from "site/rootLayout";
import { ComponentDidMount } from "utils/lifecycleMethods";
import * as Api from "./updatePaymentRedirectApi";
import { navigate } from "widgets-for-react";

interface UpdatePaymentRedirectProps {
    successUrl: string;
    updatePaymentUrl: string;
}

export const UpdatePaymentRedirectLayout = ({successUrl, updatePaymentUrl}: UpdatePaymentRedirectProps) => (
    <FormSkeletonLayout type="redirect-to-psp" kind="text-image" options={authOptions} isClrInverted={true} image={formSkeletonConfig.imageDark}>
        <ComponentDidMount onMount={async () => {
            var { hasPaymentMethod } = await Api.hasValidPaymentMethod();

            navigate(hasPaymentMethod ? successUrl : updatePaymentUrl);
        }}/>
        <RootLayout.Loader showText={false} hasWrapper />
    </FormSkeletonLayout>
)
